import { H5 } from '../Text';
import { Button, IButtonProps } from './Button';

export interface ITransparentButtonProps extends IButtonProps {}

export const TransparentButton: React.FC<ITransparentButtonProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <Button
      className={`${className} rounded border border-tt-dark-purple hover:bg-tt-gray-purple active:bg-tt-purple`}
      {...props}>
      <H5 as="span" className="block text-tt-dark-purple">{children}</H5>
    </Button>
  );
};
